'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatStrikethrough = function EditorFormatStrikethrough(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z' })
  );
};
EditorFormatStrikethrough = (0, _pure2.default)(EditorFormatStrikethrough);
EditorFormatStrikethrough.displayName = 'EditorFormatStrikethrough';
EditorFormatStrikethrough.muiName = 'SvgIcon';

exports.default = EditorFormatStrikethrough;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/format-strikethrough.js
 ** module id = 1925
 ** module chunks = 0
 **/